module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fLUzU"))).then(() => parcelRequire('1iHdE'));